export default {"src":"/_next/static/media/icons_thumbs_clickedV2.9268d089.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};